import React, { useState, useCallback } from 'react'

import { TabManager } from './TabManager'
import { TabBuyer } from './TabBuyer'
import { TabInitiator } from './TabInitiator'

enum Tabs {
    MANAGER = 'Руководителю',
    BUYER = 'Закупщику',
    INITIATOR = 'Инициатору',
}

export const OfferUsers: React.FC = () => {
    const [activeTab, setActiveTab] = useState(Tabs.MANAGER)

    const renderContent = useCallback((tab: Tabs) => {
        switch (tab) {
            case Tabs.BUYER:
                return <TabBuyer />
            case Tabs.INITIATOR:
                return <TabInitiator />
            default:
                return <TabManager />
        }
    }, [])

    return (
        <>
            <h1 className="font-bold text-white text-2xl">
                NOXSYS - одна система одна команда
            </h1>
            <ul className="flex flex-col md:flex-row gap-4 text-white">
                {Object.entries(Tabs).map(([key, value]) => (
                    <li
                        key={key}
                        className={
                            'tab_item ' +
                            (activeTab == value
                                ? 'bg-[#407bff]'
                                : 'bg-[#262427]')
                        }
                        onClick={() => setActiveTab(value)}
                    >
                        {value}
                    </li>
                ))}
            </ul>
            <div>{renderContent(activeTab)}</div>
        </>
    )
}
